import { Navigate } from '@sorare/routing';
import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav';

const HomePage = () => {
  const { generateSportContextPath } = useSportContext();
  const enableSorare27Nav = useEnableSorare27Nav();
  if (enableSorare27Nav) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_PLAY)} replace />;
  }
  return <Navigate to="classic" replace keepSearchParams />;
};

export default HomePage;
